<div id="storeComp" class="users">
  <div id="storeDataHeader" class="data_header">
    <div id="storeLeftSec" class="left_side_section" [ngClass]="{'left_side_section-lan':!isEnglish}">
      <div class="mr-3">
        <div id="storeTitle" class="title"><span i18n="@@stores.store-user.stores">Stores</span></div>
        <div id="storesResult" class="results" *ngIf="storesData?.length > 0">
          <span i18n="@@stores.store-showing.showing" class="showing">Showing <strong>{{ showFrom }} - {{
              showTo }}</strong> of <strong>{{ paginationCount }} Stores</strong></span>
        </div>
      </div>
      <div id="serachUsersInput" class="input-group" [ngClass]="{'input-group-lan':!isEnglish}">
        <input #searchValue type="search" [(ngModel)]="searchData" (keyup.enter)="searchtheUserssonEnter(searchData)"
          class="form-control input" placeholder={{searchPlaceholderText}} maxlength="75"
          (ngModelChange)="clearSearch(searchData)" />
        <div id="searchDropdownBtn" ngbDropdown class="btn-group widthInherit">
          <button ngbDropdownToggle type="button" class="btn btn-primary dropdown-toggle" id="sizeDropDown"
            aria-haspopup="true" aria-expanded="false" [ngClass]="{'dropdown-content':isEnglish}">
            {{ valueForSearch }}
          </button>
          <div id="searchDropdownList" ngbDropdownMenu aria-labelledby="sizeDropDown">
            <a ngbDropdownItem selected="selected" *ngIf="valueForSearch!=nameVal" (click)="onSelectChange('1')"><span
                i18n="@@stores.store-user.name">Name</span></a>
            <a ngbDropdownItem *ngIf="valueForSearch!=retailHQVal && userRole==='intelAdmin'"
              (click)="onSelectChange('2')"><span i18n="@@stores.store-user.retail-hq">Retail HQ</span></a>
            <a ngbDropdownItem *ngIf="valueForSearch!=locationVal" (click)="onSelectChange('3')"><span
                i18n="@@stores.store-user.location">Location</span></a>
            <a ngbDropdownItem *ngIf="valueForSearch!=customStoreIDVal" (click)="onSelectChange('4')">
              <span i18n="@@stores.store-user.custom-store-id">Custom Store ID</span>
            </a>          
          </div>
        </div>
      </div>
      <button type="button" class="btn btn-primary ml-2 search_btn gtmUsersStoresSearch"
        (click)="searchActiveUsers(searchData)">
        <img class="search_class" alt="search" />
      </button>
    </div>
    <iposcen-spinner-overlay *ngIf="showRetailGif" [isCard]="true" (getStatus)='isLoading = $event'>
    </iposcen-spinner-overlay>
    <iposcen-spinner-overlay *ngIf="!showRetailGif" [isCard]="false" (getStatus)='isLoading = $event'>
    </iposcen-spinner-overlay>
    <!-- TODO once fixe for SVG -->
    <div id="storeActionBtn" class="action_buttons">
      <button type="button" class="btn btn-outline-primary btn-lg left_icon_btn gtmUsersStoresBatchAdd"
        (click)="EnableDeleteMultipleStores()" *ngIf="!multiSelectClicked && storesData?.length > 1">
        <img class="store_delete" alt="delete store">
        <span>{{globalConst.DEL_MULTI_STORES}}</span>
      </button>
      <button type="button" class="btn btn-outline-primary btn-lg left_icon_btn gtmUsersStoresBatchAdd"
        (click)="batchCreate()" *ngIf="!multiSelectClicked">
        <svg width="24" height="24" viewBox="0 0 24 24" class="space" fill="currentColor"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M7.33071 9.30042L5.88471 9.05292C5.37346 8.96647 4.84984 8.98699 4.34692 9.11317C3.844 9.23935 3.37271 9.46845 2.96282 9.78601C2.55294 10.1036 2.21336 10.5027 1.96554 10.9581C1.71772 11.4136 1.56704 11.9155 1.52302 12.4321C1.47901 12.9487 1.54261 13.4689 1.70981 13.9597C1.87702 14.4505 2.14419 14.9013 2.49445 15.2836C2.84471 15.6659 3.27045 15.9715 3.74477 16.1809C4.2191 16.3903 4.73171 16.4991 5.25021 16.5004H9.00021V18.0004H5.25021C4.52341 18.0003 3.80454 17.8493 3.13913 17.5569C2.47372 17.2646 1.87626 16.8372 1.38459 16.302C0.892912 15.7667 0.517733 15.1352 0.282804 14.4474C0.0478744 13.7596 -0.0416861 13.0305 0.0197929 12.3063C0.0812719 11.5821 0.292451 10.8786 0.639959 10.2402C0.987466 9.6019 1.46373 9.04266 2.0386 8.59794C2.61347 8.15322 3.27441 7.83271 3.97958 7.6567C4.68475 7.48069 5.41879 7.45301 6.13521 7.57542C6.31291 6.59325 6.68479 5.6564 7.22908 4.81974C7.77336 3.98309 8.47911 3.26343 9.30499 2.70293C10.1309 2.14243 11.0603 1.75235 12.0388 1.55553C13.0173 1.3587 14.0253 1.3591 15.0037 1.55669C15.982 1.75428 16.9111 2.14509 17.7366 2.70624C18.562 3.26739 19.2672 3.98759 19.8108 4.82468C20.3545 5.66176 20.7256 6.5989 20.9025 7.58121C21.0795 8.56353 21.0586 9.57127 20.8412 10.5454C21.7716 10.6957 22.6113 11.1906 23.1934 11.9317C23.7755 12.6729 24.0573 13.6059 23.9828 14.5454C23.9083 15.4849 23.483 16.3619 22.7914 17.002C22.0998 17.6422 21.1926 17.9986 20.2502 18.0004H15.0002V16.5004H20.2502C20.8158 16.5001 21.3606 16.2867 21.7759 15.9028C22.1913 15.5188 22.4468 14.9926 22.4917 14.4287C22.5365 13.8649 22.3673 13.3049 22.0178 12.8602C21.6683 12.4154 21.1642 12.1187 20.6057 12.0289L19.0502 11.7814L19.3742 10.2394C19.5305 9.46696 19.5331 8.67127 19.3819 7.89778C19.2307 7.1243 18.9287 6.38817 18.493 5.73143C18.0573 5.07469 17.4965 4.51019 16.8427 4.07017C16.1888 3.63015 15.4547 3.32323 14.6822 3.16692C13.9097 3.01062 13.1141 3.00799 12.3406 3.15919C11.5671 3.3104 10.831 3.61247 10.1742 4.04816C9.51748 4.48385 8.95298 5.04463 8.51296 5.69849C8.07294 6.35234 7.76602 7.08646 7.60971 7.85892L7.33221 9.29892L7.33071 9.30042Z" />
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M7.49964 13.2806C7.64028 13.4212 7.83101 13.5002 8.02989 13.5002C8.22876 13.5002 8.41949 13.4212 8.56014 13.2806L11.9996 9.83964L15.4391 13.2791C15.5083 13.3508 15.5911 13.4079 15.6826 13.4472C15.7741 13.4865 15.8725 13.5072 15.9721 13.5081C16.0717 13.5089 16.1704 13.49 16.2626 13.4523C16.3548 13.4145 16.4385 13.3589 16.5089 13.2884C16.5794 13.218 16.635 13.1343 16.6728 13.0421C16.7105 12.9499 16.7294 12.8512 16.7286 12.7516C16.7277 12.652 16.707 12.5536 16.6677 12.4621C16.6284 12.3706 16.5713 12.2878 16.4996 12.2186L12.5306 8.24964C12.461 8.17979 12.3782 8.12438 12.2871 8.08657C12.196 8.04876 12.0983 8.0293 11.9996 8.0293C11.901 8.0293 11.8033 8.04876 11.7122 8.08657C11.6211 8.12438 11.5383 8.17979 11.4686 8.24964L7.49964 12.2186C7.42979 12.2883 7.37438 12.3711 7.33657 12.4622C7.29876 12.5533 7.2793 12.651 7.2793 12.7496C7.2793 12.8483 7.29876 12.946 7.33657 13.0371C7.37438 13.1282 7.42979 13.211 7.49964 13.2806Z" />
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M12 9C12.1989 9 12.3897 9.07902 12.5303 9.21967C12.671 9.36032 12.75 9.55109 12.75 9.75V21.75C12.75 21.9489 12.671 22.1397 12.5303 22.2803C12.3897 22.421 12.1989 22.5 12 22.5C11.8011 22.5 11.6103 22.421 11.4697 22.2803C11.329 22.1397 11.25 21.9489 11.25 21.75V9.75C11.25 9.55109 11.329 9.36032 11.4697 9.21967C11.6103 9.07902 11.8011 9 12 9Z" />
        </svg>
        <span i18n="@@stores.store-user.batch-add">Batch Add</span>
      </button>
      <!-- TODO once fixe for SVG -->
      <button type="button" class="btn btn-primary btn-lg left_icon_btn gtmUsersNewStore" (click)="createNewStores()"
        *ngIf="!multiSelectClicked">
        <svg width="24" height="24" class="space" viewBox="0 0 24 24" fill="currentColor"
          xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0)">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M12 5.25C12.1989 5.25 12.3897 5.32902 12.5303 5.46967C12.671 5.61032 12.75 5.80109 12.75 6V12C12.75 12.1989 12.671 12.3897 12.5303 12.5303C12.3897 12.671 12.1989 12.75 12 12.75H6C5.80109 12.75 5.61032 12.671 5.46967 12.5303C5.32902 12.3897 5.25 12.1989 5.25 12C5.25 11.8011 5.32902 11.6103 5.46967 11.4697C5.61032 11.329 5.80109 11.25 6 11.25H11.25V6C11.25 5.80109 11.329 5.61032 11.4697 5.46967C11.6103 5.32902 11.8011 5.25 12 5.25Z" />
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M11.25 12C11.25 11.8011 11.329 11.6103 11.4697 11.4697C11.6103 11.329 11.8011 11.25 12 11.25H18C18.1989 11.25 18.3897 11.329 18.5303 11.4697C18.671 11.6103 18.75 11.8011 18.75 12C18.75 12.1989 18.671 12.3897 18.5303 12.5303C18.3897 12.671 18.1989 12.75 18 12.75H12.75V18C12.75 18.1989 12.671 18.3897 12.5303 18.5303C12.3897 18.671 12.1989 18.75 12 18.75C11.8011 18.75 11.6103 18.671 11.4697 18.5303C11.329 18.3897 11.25 18.1989 11.25 18V12Z" />
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M21 1.5H3C2.60218 1.5 2.22064 1.65804 1.93934 1.93934C1.65804 2.22064 1.5 2.60218 1.5 3V21C1.5 21.3978 1.65804 21.7794 1.93934 22.0607C2.22064 22.342 2.60218 22.5 3 22.5H21C21.3978 22.5 21.7794 22.342 22.0607 22.0607C22.342 21.7794 22.5 21.3978 22.5 21V3C22.5 2.60218 22.342 2.22064 22.0607 1.93934C21.7794 1.65804 21.3978 1.5 21 1.5ZM3 0C2.20435 0 1.44129 0.316071 0.87868 0.87868C0.316071 1.44129 0 2.20435 0 3L0 21C0 21.7956 0.316071 22.5587 0.87868 23.1213C1.44129 23.6839 2.20435 24 3 24H21C21.7956 24 22.5587 23.6839 23.1213 23.1213C23.6839 22.5587 24 21.7956 24 21V3C24 2.20435 23.6839 1.44129 23.1213 0.87868C22.5587 0.316071 21.7956 0 21 0L3 0Z" />
          </g>
          <defs>
            <clipPath id="clip0">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
        <span i18n="@@stores.store-user.new-store">New Store</span>
      </button>
      <button type="button" class="btn btn-outline-primary btn-lg left_icon_btn gtmUsersStoresBatchAdd"
        *ngIf="multiSelectClicked" (click)="cancelMultiSelect()">
        <span>{{globalConst.CANCEL}}</span>
      </button>
      <button type="button" class="btn btn-primary btn-lg left_icon_btn gtmUsersNewStore" *ngIf="multiSelectClicked"
        (click)="showMultiStoreDelPopup()" [disabled]="checkDisable()">
        <img alt="delete store" [ngClass]="checkDisable()?'disabled_white':'blue_delete_icon'">
        <span>{{globalConst.DEL_SELECTED}}</span>
      </button>
    </div>
  </div>
  <!-- Filter Data  -->
  <div id="searchFilterOption" class="filter_options">
    <div id="filters" class="form-inline">
      <span id="filterfont" class="mr-4" i18n="@@stores.store-user.filters">Filters</span>&nbsp;&nbsp;
      <select #drop1 (change)="filter(retailhqFilterName, drop1.value)" class="btn-greyscale btn-sm dropdown-toggle"
        [ngClass]="{'btn-greyscale-lan': !isEnglish}" aria-haspopup="true" aria-expanded="false"
        *ngIf="!retailHQDropdownSelectedValue && userRole!='retailHQUser' && userRole!='regionalHQ'">
        <option selected default class="option-default"><span i18n="@@stores.store-user.retail-hqs">Retail HQs</span>
        </option>
        <option class="dropdown-item" *ngFor="let data of hqRetailer" [value]="data">
          {{ data.length > 25 ? (data | slice:0:25) + '...' : data }}
        </option>
      </select>
      <div [ngbTooltip]="retailHQDropdownSelectedValue?.length > 25 ? retailHQDropdownSelectedValue:''"
        class="dropdown-selected" *ngIf="retailHQDropdownSelectedValue">{{retailHQDropdownSelectedValue?.length > 25 ?
        (retailHQDropdownSelectedValue | slice:0:25) + '...' : retailHQDropdownSelectedValue}}
        <img class="dropdown-selected-img" (click)="clearFilter(retailhqFilterName)" alt="close" />
      </div>
      &nbsp;&nbsp;
      <select #drop2 (change)="filter(countryFilterName, drop2.value)" class="btn-greyscale btn-sm dropdown-toggle"
        [ngClass]="{'btn-greyscale-lan': !isEnglish}" aria-haspopup="true" aria-expanded="false"
        *ngIf="!countriesDropdownSelectedValue">
        <option selected default class="option-default"><span i18n="@@stores.store-user.location">Location</span>
        </option>
        <option class="dropdown-item" *ngFor="let data of countryList" [value]="data">
          {{ getTranslatedLoc(data) }}
        </option>
      </select>
      <div class="dropdown-selected" *ngIf="countriesDropdownSelectedValue">{{countriesDropdownSelectedValue}}
        <img class="dropdown-selected-img" (click)="clearFilter(countryFilterName)" alt="close" />
      </div>
      &nbsp;&nbsp;
      <select #drop3 (change)="filter(stateFilterName, drop3.value)" class="btn-greyscale btn-sm dropdown-toggle"
        [ngClass]="{'btn-greyscale-lan': !isEnglish}" aria-haspopup="true" aria-expanded="false"
        *ngIf="!stateDropdownSelectedValue">
        <option selected default class="option-default"><span
            i18n="@@stores.store-user.state-province-regions">State/Province/Regions</span>
        </option>
        <option class="dropdown-item" *ngFor="let data of stateProvinceRegions" [value]="data">
          {{ data }}
        </option>
      </select>
      <div class="dropdown-selected" *ngIf="stateDropdownSelectedValue">{{stateDropdownSelectedValue}}
        <img class="dropdown-selected-img" (click)="clearFilter(stateFilterName)" alt="close" />
      </div>
    </div>
    <div id="clearFilter" class="btn left_icon_btn" (click)="clearFilter()" *ngIf="closeFilter">
      <img class="dropdown-selected-img" alt="close" />
      <span class="btn-link" i18n="@@stores.store-user.clear-filters">Clear Filters</span>
    </div>
  </div>
  <hr />

  <div id="addStoreCont" class="container">
    <div id="addStoreModal" class="modal-dialog modal-dialog-centered" *ngIf="openModal">
      <div id="addStoreBackdrop" class="modal-backdrop show"></div>
      <div class="modal" id="myModal">
        <div id="addStoreDialog" class="modal-dialog">
          <div class="modal-content" [ngClass]="selectedLangEng?'':'notAEnglishList'">
            <div id="addStoreCloseIcon"  class="close" data-dismiss="modal" (click)="CloseBatchadd()">
              <img class="modal-close-icon" alt="close" />
            </div>
            <div id="addStoreModalBody"  class="modal-body poupBody" [ngClass]="selectedLangEng?'':'extraPaddingForNonEnglish'">
              <div id="addCsvHeading"  class="heading csv-modal-heading"><span i18n="@@stores.store-user.add-stories-csv">Add Stores via
                  CSV</span></div>
              <ol id="dowloadCsvTemp" class="scrollablewrapper">
                <li><a
                  (click)="downloadTemplate()" [download]="downloadFile" class="download"><span
                    i18n="@@stores.store-user.download-csv-templates">Download CSV Template</span></a>
                  </li>
                <div id="uploadCsv"  class="csv-upload-div">
                  <li> {{globalConst.STORES_BATCH_POPUP_CSV_TEMPLATE_TEXT}}</li>
                </div>
                <div id="locationList" class="location-input-name">
                  <li> {{globalConst.STORES_BATCH_POPUP_INPUT_CSV_TEXT}} </li>
                  <div class="mt-2 store-csv-location-main-div" id="locationListDiv">
                    <div class="table_collapse_link collapsed location-list-div" data-toggle="collapse"
                      [attr.aria-expanded]="isExpanded" aria-controls="collapseThree">
                      <span i18n="@@store.countries-dropdown.location-label">Location List</span>
                      <div id="getLocationList" class="expand-arrow-styl" (click)="getLocationList()">
                        <img class="table_row_expanded location-list-arrow" alt="expand"
                          [ngClass]="isExpanded?'transform-180':''" />
                      </div>
                    </div>

                    <div class="collapse location-list-section-div" id="collapseThree" data-parent="#locationListDiv"
                      #collapse="ngbCollapse" [(ngbCollapse)]="!isExpanded" aria-labelledby="locationListSection">
                      <div id="locationCardBody" class="card-body" *ngIf="selectedLangEng">
                        <div class="row">
                          <div id="col1" class="col">
                            <div id="locationList1" class="alphabetical_list" *ngFor="let location of locationListColumnOne;">
                              <div id="locationOrder1" class="legend">{{location.order}}</div>
                              <div id="locationName1" *ngFor="let item of location.name;">
                                <div>{{item}}</div>
                              </div>
                            </div>
                          </div>
                          <div id="col2" class="col">
                            <div id="locationList2" class="alphabetical_list" *ngFor="let location of locationListColumnTwo;">
                              <div id="locationOrder2" class="legend">{{location.order}}</div>
                              <div id="locationName2" *ngFor="let item of location.name;">
                                <div>{{item}}</div>
                              </div>
                            </div>
                          </div>
                          <div id="col3" class="col">
                            <div id="locationList3" class="alphabetical_list" *ngFor="let location of locationListColumnThree;">
                              <div id="locationOrder3" class="legend">{{location.order}}</div>
                              <div id="locationName3" *ngFor="let item of location.name;">
                                <div>{{item}}</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div id="nonEngliseSec" class="card-body" *ngIf="!selectedLangEng">
                        <div class="row nonEnglish">
                          <div id="nonEngCol1" class="col-6">
                            <div  id="locationList4" class="mainDiv" *ngFor="let location of locationListColumnOne;">
                              <div class="d-flex">
                                <div  id="locationOrder4" class="item-name legend"> {{location.order}} </div>
                              </div>
                              <div id="locationList5" class="d-flex" *ngFor="let item of location.name,let i = index">
                                <div  id="locationName5" class="item-name"> {{item}}</div>
                              </div>
                            </div>
                          </div>
                          <div id="nonEngCol2" class="col-6">
                            <div id="locationList6" class="mainDiv" *ngFor="let location of locationListColumnTwo;">
                              <div class="d-flex">
                                <div id="locationOrder6"  class="item-name legend"> {{location.order}} </div>
                              </div>
                              <div  class="d-flex" *ngFor="let item of location.name,let i = index">
                                <div id="locationName6" class="item-name"> {{item}}</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div *ngIf="userRole === intelAdmin" id="uploadTemp" class="upload-submit-txt">
                  <li><span i18n="@@stores.store-user.retailer-id-name">Enter Retailer ID and Name of the Retail HQ</span></li>
                </div>
                <div id="uploadTemp" class="upload-submit-txt">
                  <li><span i18n="@@stores.store-user.csv-upload-comp-template">Upload and submit the completed template</span>:</li>
                </div>
                <div id="uploadCsvNote">{{uploadCSVNote}}</div>
                <!-- TODO once fixe for SVG -->
                <div id="csvFilePicker">
                  <input type="file" id="file-picker" (change)="onFilechange($event)" accept=".csv" hidden />
                  <button type="button" class="btn btn-primary btn-lg left_icon_btn upload-csv-btn"
                    (click)="document.getElementById('file-picker').click()">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M7.33071 9.30042L5.88471 9.05292C5.37346 8.96647 4.84984 8.98699 4.34692 9.11317C3.844 9.23935 3.37271 9.46845 2.96282 9.78601C2.55294 10.1036 2.21336 10.5027 1.96554 10.9581C1.71772 11.4136 1.56704 11.9155 1.52302 12.4321C1.47901 12.9487 1.54261 13.4689 1.70981 13.9597C1.87702 14.4505 2.14419 14.9013 2.49445 15.2836C2.84471 15.6659 3.27045 15.9715 3.74477 16.1809C4.2191 16.3903 4.73171 16.4991 5.25021 16.5004H9.00021V18.0004H5.25021C4.52341 18.0003 3.80454 17.8493 3.13913 17.5569C2.47372 17.2646 1.87626 16.8372 1.38459 16.302C0.892912 15.7667 0.517733 15.1352 0.282804 14.4474C0.0478744 13.7596 -0.0416861 13.0305 0.0197929 12.3063C0.0812719 11.5821 0.292451 10.8786 0.639959 10.2402C0.987466 9.6019 1.46373 9.04266 2.0386 8.59794C2.61347 8.15322 3.27441 7.83271 3.97958 7.6567C4.68475 7.48069 5.41879 7.45301 6.13521 7.57542C6.31291 6.59325 6.68479 5.6564 7.22908 4.81974C7.77336 3.98309 8.47911 3.26343 9.30499 2.70293C10.1309 2.14243 11.0603 1.75235 12.0388 1.55553C13.0173 1.3587 14.0253 1.3591 15.0037 1.55669C15.982 1.75428 16.9111 2.14509 17.7366 2.70624C18.562 3.26739 19.2672 3.98759 19.8108 4.82468C20.3545 5.66176 20.7256 6.5989 20.9025 7.58121C21.0795 8.56353 21.0586 9.57127 20.8412 10.5454C21.7716 10.6957 22.6113 11.1906 23.1934 11.9317C23.7755 12.6729 24.0573 13.6059 23.9828 14.5454C23.9083 15.4849 23.483 16.3619 22.7914 17.002C22.0998 17.6422 21.1926 17.9986 20.2502 18.0004H15.0002V16.5004H20.2502C20.8158 16.5001 21.3606 16.2867 21.7759 15.9028C22.1913 15.5188 22.4468 14.9926 22.4917 14.4287C22.5365 13.8649 22.3673 13.3049 22.0178 12.8602C21.6683 12.4154 21.1642 12.1187 20.6057 12.0289L19.0502 11.7814L19.3742 10.2394C19.5305 9.46696 19.5331 8.67127 19.3819 7.89778C19.2307 7.1243 18.9287 6.38817 18.493 5.73143C18.0573 5.07469 17.4965 4.51019 16.8427 4.07017C16.1888 3.63015 15.4547 3.32323 14.6822 3.16692C13.9097 3.01062 13.1141 3.00799 12.3406 3.15919C11.5671 3.3104 10.831 3.61247 10.1742 4.04816C9.51748 4.48385 8.95298 5.04463 8.51296 5.69849C8.07294 6.35234 7.76602 7.08646 7.60971 7.85892L7.33221 9.29892L7.33071 9.30042Z" />
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M7.49964 13.2806C7.64028 13.4212 7.83101 13.5002 8.02989 13.5002C8.22876 13.5002 8.41949 13.4212 8.56014 13.2806L11.9996 9.83964L15.4391 13.2791C15.5083 13.3508 15.5911 13.4079 15.6826 13.4472C15.7741 13.4865 15.8725 13.5072 15.9721 13.5081C16.0717 13.5089 16.1704 13.49 16.2626 13.4523C16.3548 13.4145 16.4385 13.3589 16.5089 13.2884C16.5794 13.218 16.635 13.1343 16.6728 13.0421C16.7105 12.9499 16.7294 12.8512 16.7286 12.7516C16.7277 12.652 16.707 12.5536 16.6677 12.4621C16.6284 12.3706 16.5713 12.2878 16.4996 12.2186L12.5306 8.24964C12.461 8.17979 12.3782 8.12438 12.2871 8.08657C12.196 8.04876 12.0983 8.0293 11.9996 8.0293C11.901 8.0293 11.8033 8.04876 11.7122 8.08657C11.6211 8.12438 11.5383 8.17979 11.4686 8.24964L7.49964 12.2186C7.42979 12.2883 7.37438 12.3711 7.33657 12.4622C7.29876 12.5533 7.2793 12.651 7.2793 12.7496C7.2793 12.8483 7.29876 12.946 7.33657 13.0371C7.37438 13.1282 7.42979 13.211 7.49964 13.2806Z" />
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M12 9C12.1989 9 12.3897 9.07902 12.5303 9.21967C12.671 9.36032 12.75 9.55109 12.75 9.75V21.75C12.75 21.9489 12.671 22.1397 12.5303 22.2803C12.3897 22.421 12.1989 22.5 12 22.5C11.8011 22.5 11.6103 22.421 11.4697 22.2803C11.329 22.1397 11.25 21.9489 11.25 21.75V9.75C11.25 9.55109 11.329 9.36032 11.4697 9.21967C11.6103 9.07902 11.8011 9 12 9Z" />
                    </svg>
                    <span i18n="@@stores.store-user.upload-csv">Upload CSV</span>
                  </button>
                  <div id="showFileName" class="text-align-filename" *ngIf="!showcsvError && !incorrectError && !isStoreNameDuplicateError" title="{{ fileName }}">
                    {{ finalName }}
                  </div>
                  <div id="noNewStoreError" class="text-align-filename" *ngIf="isStoreModified">
                    <span class="text-danger">CSV cannot be uploaded. There is no new store data or updates to existing stores in the uploaded CSV</span>
                  </div>
                  <div id="showcsvError" class="text-align-filename" *ngIf="showcsvError">
                    <span class="text-danger" i18n="@@stores.store-user.file-must-csv">File must be in CSV format</span>
                  </div>
                  <div id="storeNameDuplicateError" class="text-align-filename" *ngIf="isStoreNameDuplicateError">
                    <span class="text-danger">CSV cannot be uploaded. Store name is duplicate in the uploaded CSV</span>
                  </div>
                  <!-- IIT2-1423 -->
                  <div id="uploadCsvError" class="text-align-filename csv-upload-popup" *ngIf="incorrectError">
                    <span class="text-danger">{{uploadedCSVGeneralError}}</span>
                    <div id="uploadCsvErrorMsg" *ngFor="let error of errorMessage | keyvalue: returnDefault">
                      <span class="text-danger">{{error.key}} : {{error.value}}</span>
                    </div>
                  </div>
                  <!-- IIT2-1423 end-->
                </div>
              </ol>
              <div id="modalActionBtn" class="modal-footer">
                <div class="button-wrapper" id="batch_btn">
                  <button type="button" class="btn btn-outline-primary gtmUsersStoresCloseBatchAdd"
                    (click)="CloseBatchadd()">
                    <span i18n="@@stores.store-user.cancel-button">Cancel</span>
                  </button>
                  <button type="button" (click)="uploadFile()" class="btn btn-primary"
                    [disabled]="!finalName || showcsvError || isStoreNameDuplicateError">
                    <span i18n="@@stores.store-user.submit-csv">Submit CSV</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Table data -->
  <div id="storeTableData" class="table-responsive">
    <table id="storesTable" class="table table-borderless" aria-describedby="stores">
      <thead>
        <tr *ngIf="storesData?.length">
          <th scope="col"
            *ngIf="multiSelectClicked && userRole == intelAdmin && !this.retailHQDropdownSelectedValue; else otherPart">
            <input type="checkbox" (change)="selectDeSelectAll($event,globalConst.ALL_TEXT)" placement="right"
              ngbTooltip={{globalConst.SELECT_ALL_POPUP_TEXT}} tooltipClass="my-custom-class"
              [ngClass]="!retailHQDropdownSelectedValue && userRole == this.intelAdmin? 'disableCheckBox':''" />
          </th>
          <ng-template #otherPart>
            <th scope="col" *ngIf="multiSelectClicked">
              <input type="checkbox" [checked]="checkUncheckFlag || selectDeSelectAllFlag" (change)="selectDeSelectAll($event,globalConst.ALL_TEXT)" />
            </th>
          </ng-template>
          <th scope="col" id="storeName">
            <span class="table_headings" (click)="sort('storeName')">
              <span i18n="@@stores.store-user.name">Name</span>
              <span class="chevron_expand"></span>
            </span>
          </th>
          <th scope="col" id="retailHq">
            <span class="table_headings" i18n="@@stores.store-user.retail-hq">Retail HQ</span>
          </th>
          <th scope="col" id="custstoreID">
            <span class="table_headings" (click)="sort('custStoreId')">
              <span i18n="@@stores.store-user.custom-store-id"> Custom Store ID </span>
              <span class="chevron_expand"></span>
            </span>
          </th>
          <th scope="col" id="createby">
            <span class="table_headings" i18n="@@stores.store-user.created-by">Created By</span>
          </th>
          <th scope="col" id="storenum">
            <span class="table_headings" (click)="sort('storenumber')">
              <span i18n="@@stores.store-user.store-number">Store Number</span>
              <span class="chevron_expand"></span>
            </span>
          </th>
          <th scope="col" id="country">
            <span class="table_headings" (click)="sort('country')">
              <span i18n="@@stores.store-user.location">Location</span>
              <span class="chevron_expand"></span>
            </span>
          </th>
          <th scope="col" id="region">
            <span class="table_headings" (click)="sort('region')">
              <span i18n="@@stores.store-user.state-province-region">State/Province/Region</span>
              <span class="chevron_expand"></span>
            </span>
          </th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="
            let data of storesData;let i = index">
          <tr class="row_hover">
            <td *ngIf="multiSelectClicked">
              <input type="checkbox" [checked]='selectedStores[storesData[i].storeId]'
                (change)="selectDeSelectAll($event,globalConst.SINGLE,storesData[i].storeId,data)" [disabled]="" />
            </td>
            <td>{{ data?.storeName }}</td>
            <td>{{ data?.retailerName }}</td>
            <td *ngIf="!data.customStoreID">{{ data?.customStoreID }}</td>
            <td *ngIf="data.customStoreID">{{ data?.customStoreID }}</td>
            <td>{{ data?.createdByName }}</td>
            <td>{{ data?.storeNumber }}</td>
            <td>{{ getTranslatedLoc(data?.country) }}</td>
            <td>{{ data?.stateRegionProvince }}</td>
            <td class="action_cell">
              <div class="modify_record">
                <!-- TODO once fixe for SVG -->
                <button type="button" id="invite_user_button" class="btn btn-link left_icon_btn"
                  [ngbTooltip]="inviteTooltip" (click)="inviteStoreUser(data)"
                  *ngIf="!showEditSave[i] && !buttonShow[i]">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0)">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M10 4.375C10.1658 4.375 10.3247 4.44085 10.4419 4.55806C10.5592 4.67527 10.625 4.83424 10.625 5V10C10.625 10.1658 10.5592 10.3247 10.4419 10.4419C10.3247 10.5592 10.1658 10.625 10 10.625H5C4.83424 10.625 4.67527 10.5592 4.55806 10.4419C4.44085 10.3247 4.375 10.1658 4.375 10C4.375 9.83424 4.44085 9.67527 4.55806 9.55806C4.67527 9.44085 4.83424 9.375 5 9.375H9.375V5C9.375 4.83424 9.44085 4.67527 9.55806 4.55806C9.67527 4.44085 9.83424 4.375 10 4.375Z" />
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M9.375 10C9.375 9.83424 9.44085 9.67527 9.55806 9.55806C9.67527 9.44085 9.83424 9.375 10 9.375H15C15.1658 9.375 15.3247 9.44085 15.4419 9.55806C15.5592 9.67527 15.625 9.83424 15.625 10C15.625 10.1658 15.5592 10.3247 15.4419 10.4419C15.3247 10.5592 15.1658 10.625 15 10.625H10.625V15C10.625 15.1658 10.5592 15.3247 10.4419 15.4419C10.3247 15.5592 10.1658 15.625 10 15.625C9.83424 15.625 9.67527 15.5592 9.55806 15.4419C9.44085 15.3247 9.375 15.1658 9.375 15V10Z" />
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M10 18.75C12.3206 18.75 14.5462 17.8281 16.1872 16.1872C17.8281 14.5462 18.75 12.3206 18.75 10C18.75 7.67936 17.8281 5.45376 16.1872 3.81282C14.5462 2.17187 12.3206 1.25 10 1.25C7.67936 1.25 5.45376 2.17187 3.81282 3.81282C2.17187 5.45376 1.25 7.67936 1.25 10C1.25 12.3206 2.17187 14.5462 3.81282 16.1872C5.45376 17.8281 7.67936 18.75 10 18.75ZM10 20C12.6522 20 15.1957 18.9464 17.0711 17.0711C18.9464 15.1957 20 12.6522 20 10C20 7.34784 18.9464 4.8043 17.0711 2.92893C15.1957 1.05357 12.6522 0 10 0C7.34784 0 4.8043 1.05357 2.92893 2.92893C1.05357 4.8043 0 7.34784 0 10C0 12.6522 1.05357 15.1957 2.92893 17.0711C4.8043 18.9464 7.34784 20 10 20Z" />
                    </g>
                    <defs>
                      <clipPath id="clip0">
                        <rect width="20" height="20" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </button>
                <button type="button" class="btn btn-link left_icon_btn" [ngbTooltip]="inviteTooltip"
                  (click)="inviteStoreUser(data)" *ngIf="!showEditSave[i] && buttonShow[i]">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0)">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M10 4.375C10.1658 4.375 10.3247 4.44085 10.4419 4.55806C10.5592 4.67527 10.625 4.83424 10.625 5V10C10.625 10.1658 10.5592 10.3247 10.4419 10.4419C10.3247 10.5592 10.1658 10.625 10 10.625H5C4.83424 10.625 4.67527 10.5592 4.55806 10.4419C4.44085 10.3247 4.375 10.1658 4.375 10C4.375 9.83424 4.44085 9.67527 4.55806 9.55806C4.67527 9.44085 4.83424 9.375 5 9.375H9.375V5C9.375 4.83424 9.44085 4.67527 9.55806 4.55806C9.67527 4.44085 9.83424 4.375 10 4.375Z" />
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M9.375 10C9.375 9.83424 9.44085 9.67527 9.55806 9.55806C9.67527 9.44085 9.83424 9.375 10 9.375H15C15.1658 9.375 15.3247 9.44085 15.4419 9.55806C15.5592 9.67527 15.625 9.83424 15.625 10C15.625 10.1658 15.5592 10.3247 15.4419 10.4419C15.3247 10.5592 15.1658 10.625 15 10.625H10.625V15C10.625 15.1658 10.5592 15.3247 10.4419 15.4419C10.3247 15.5592 10.1658 15.625 10 15.625C9.83424 15.625 9.67527 15.5592 9.55806 15.4419C9.44085 15.3247 9.375 15.1658 9.375 15V10Z" />
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M10 18.75C12.3206 18.75 14.5462 17.8281 16.1872 16.1872C17.8281 14.5462 18.75 12.3206 18.75 10C18.75 7.67936 17.8281 5.45376 16.1872 3.81282C14.5462 2.17187 12.3206 1.25 10 1.25C7.67936 1.25 5.45376 2.17187 3.81282 3.81282C2.17187 5.45376 1.25 7.67936 1.25 10C1.25 12.3206 2.17187 14.5462 3.81282 16.1872C5.45376 17.8281 7.67936 18.75 10 18.75ZM10 20C12.6522 20 15.1957 18.9464 17.0711 17.0711C18.9464 15.1957 20 12.6522 20 10C20 7.34784 18.9464 4.8043 17.0711 2.92893C15.1957 1.05357 12.6522 0 10 0C7.34784 0 4.8043 1.05357 2.92893 2.92893C1.05357 4.8043 0 7.34784 0 10C0 12.6522 1.05357 15.1957 2.92893 17.0711C4.8043 18.9464 7.34784 20 10 20Z" />
                    </g>
                    <defs>
                      <clipPath id="clip0">
                        <rect width="20" height="20" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </button>
                <!-- TODO once fixed for SVG -->
                <button type="button" id="edit_button" class="btn btn-link left_icon_btn"
                  (click)="getEditableData(i, data)" [ngbTooltip]="editTooltip"
                  *ngIf="!showEditSave[i] && !buttonShow[i]">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M14.1159 1.61598C14.3503 1.38164 14.6682 1.25 14.9996 1.25C15.3311 1.25 15.649 1.38164 15.8834 1.61598L18.3834 4.11598C18.6177 4.35039 18.7494 4.66828 18.7494 4.99973C18.7494 5.33119 18.6177 5.64907 18.3834 5.88348L7.13338 17.1335C6.99653 17.2707 6.82964 17.3743 6.64588 17.436L2.89588 18.686C2.67556 18.7597 2.43905 18.7706 2.21288 18.7175C1.98671 18.6643 1.77984 18.5491 1.61549 18.3849C1.45114 18.2207 1.33581 18.0139 1.28244 17.7878C1.22908 17.5616 1.23979 17.3251 1.31338 17.1047L2.56338 13.3547C2.62488 13.1705 2.72845 13.0032 2.86588 12.866L14.1159 1.61598ZM14.9996 2.49973L17.4996 4.99973L6.24963 16.2497L2.49963 17.4997L3.74963 13.7497L14.9996 2.49973Z" />
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M15.1825 7.94164L12.0575 4.81664L12.9425 3.93164L16.0675 7.05664L15.1838 7.94164H15.1825ZM3.75 12.4991V13.1241C3.75 13.2899 3.81585 13.4489 3.93306 13.5661C4.05027 13.6833 4.20924 13.7491 4.375 13.7491H5V14.3741C5 14.5399 5.06585 14.6989 5.18306 14.8161C5.30027 14.9333 5.45924 14.9991 5.625 14.9991H6.25V15.6241C6.25 15.7899 6.31585 15.9489 6.43306 16.0661C6.55027 16.1833 6.70924 16.2491 6.875 16.2491H7.5V14.3741C7.5 14.2084 7.43415 14.0494 7.31694 13.9322C7.19973 13.815 7.04076 13.7491 6.875 13.7491H6.25V13.1241C6.25 12.9584 6.18415 12.7994 6.06694 12.6822C5.94973 12.565 5.79076 12.4991 5.625 12.4991H3.75Z" />
                  </svg>
                </button>
                <button type="button" class="btn btn-link left_icon_btn" (click)="getEditableData(i, data)"
                  [ngbTooltip]="editTooltip" *ngIf="!showEditSave[i] && buttonShow[i]">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M14.1159 1.61598C14.3503 1.38164 14.6682 1.25 14.9996 1.25C15.3311 1.25 15.649 1.38164 15.8834 1.61598L18.3834 4.11598C18.6177 4.35039 18.7494 4.66828 18.7494 4.99973C18.7494 5.33119 18.6177 5.64907 18.3834 5.88348L7.13338 17.1335C6.99653 17.2707 6.82964 17.3743 6.64588 17.436L2.89588 18.686C2.67556 18.7597 2.43905 18.7706 2.21288 18.7175C1.98671 18.6643 1.77984 18.5491 1.61549 18.3849C1.45114 18.2207 1.33581 18.0139 1.28244 17.7878C1.22908 17.5616 1.23979 17.3251 1.31338 17.1047L2.56338 13.3547C2.62488 13.1705 2.72845 13.0032 2.86588 12.866L14.1159 1.61598ZM14.9996 2.49973L17.4996 4.99973L6.24963 16.2497L2.49963 17.4997L3.74963 13.7497L14.9996 2.49973Z" />
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M15.1825 7.94164L12.0575 4.81664L12.9425 3.93164L16.0675 7.05664L15.1838 7.94164H15.1825ZM3.75 12.4991V13.1241C3.75 13.2899 3.81585 13.4489 3.93306 13.5661C4.05027 13.6833 4.20924 13.7491 4.375 13.7491H5V14.3741C5 14.5399 5.06585 14.6989 5.18306 14.8161C5.30027 14.9333 5.45924 14.9991 5.625 14.9991H6.25V15.6241C6.25 15.7899 6.31585 15.9489 6.43306 16.0661C6.55027 16.1833 6.70924 16.2491 6.875 16.2491H7.5V14.3741C7.5 14.2084 7.43415 14.0494 7.31694 13.9322C7.19973 13.815 7.04076 13.7491 6.875 13.7491H6.25V13.1241C6.25 12.9584 6.18415 12.7994 6.06694 12.6822C5.94973 12.565 5.79076 12.4991 5.625 12.4991H3.75Z" />
                  </svg>
                </button>
                <!--IIT2-7833 Starts-->
                <button type="button" id="invite_user_button" class="btn btn-link left_icon_btn"
                  [ngbTooltip]="deleteTooltipLabel" (click)="openStoreDeletePopup(data)"
                  *ngIf="!showEditSave[i] && !buttonShow[i] && userRole !== 'nonConnectedUser' && !multiSelectClicked">
                  <img class="store_delete" alt="delete store">
                </button>
                <button type="button" class="btn btn-link left_icon_btn" [ngbTooltip]="deleteTooltipLabel"
                  (click)="openStoreDeletePopup(data)"
                  *ngIf="!showEditSave[i] && buttonShow[i] && userRole !== 'nonConnectedUser' && !multiSelectClicked">
                  <img class="store_delete" alt="delete store">
                </button>
                <iposcen-delete-popup #deleteModal [contentName]="storeName" [isStoreDelete]="true"
                  (delete)="deleteIndividualStore(storeId)" [isStoreContent]="isStoreAssociated"></iposcen-delete-popup>
                <iposcen-delete-acknowledgement-dialog #deleteAckModal [sourceString]="storeName"
                  [isStoreDeleteCnfrm]="true">
                </iposcen-delete-acknowledgement-dialog>
                <!--IIT2-7833 Ends-->
                <!-- for multi store delete 7834-->
                <iposcen-delete-popup #deleteMultiStoreModal [popupHeader]="globalConst.MULTI_STORE_DELETE_POPUP_HDR"
                  [bodyContent]="contentName" (delete)="deleteMultiStore()"
                  [buttonName]="globalConst.USERS_STORES_CSV_FILENAME"></iposcen-delete-popup>
                <iposcen-delete-acknowledgement-dialog #deleteMultiAckModal [sourceString]="storeName"
                  [isMultiStoreDeleteCnfrm]="true" (delete)="closeTriggered()">
                </iposcen-delete-acknowledgement-dialog>
                <!-- for multi store delete 7834 end-->
                <div id="editButton">
                  <button type="button" *ngIf="showEditSave[i]"
                    class="btn btn-outline-primary btn-sm gtmUsersStoresCancelEdit"
                    (click)="cancelEdit(data?.storeId, i)">
                    <span i18n="@@stores.store-user.cancel-button">Cancel</span>
                  </button>
                  &nbsp;&nbsp;
                  <button type="button" *ngIf="showEditSave[i]" class="btn btn-primary btn-sm gtmUsersStoresSaveChanges"
                    (click)="editStore(data, i)">
                    <span i18n="@@stores.store-user.save-changes">Save Changes</span>
                  </button>
                </div>

                <span class="table_collapse_link collapsed" data-toggle="collapse" aria-expanded="true"
                  data-target="#storesTable">
                  <img class="table_row_expanded" alt="expand" [ngClass]="expanded[i] ? 'transform-180' : ''"
                    (click)="getStoresbyID(i)" />
                </span>
              </div>
            </td>
          </tr>
          <!-- TODO in the Next PR  instead of DIV, Forms should be replaced-->
          <tr *ngIf="expanded[i]" class="detail_row_view" data-parent="#storesTable">
            <td colspan="100%">
              <div class="d-flex">
                <div class="border-right">
                  <div class="margin-r-30">
                    <div id="expand_data_region"><span i18n="@@stores.store-user.details">Details</span></div>
                    <div class="expand_editable_data">
                      <div class="form-group">
                        <label><span i18n="@@stores.store-user.name">Name</span></label>
                        <div *ngIf="!isEditable[i]" class="exapnd_data_det">
                          {{ data?.storeName }}
                        </div>
                        <input *ngIf="isEditable[i]" type="text" value="{{ data?.storeName }}"
                          [(ngModel)]="data.storeName" [ngClass]="{'change-border':data?.storeName}"
                          class="form-control" />
                          <div *ngIf="isStoreNameUnique" class="text-danger err-field"><span
                            i18n="@@stores.store-user.store-name-unique-error">Store Name already exists</span>
                          </div>
                      </div>
                      <div class="form-group">
                        <label><span i18n="@@stores.store-user.store-code">Store Code</span></label>
                        <div class="exapnd_data_det">{{ data?.storeId }}</div>
                      </div>
                      <div class="form-group">
                        <label><span i18n="@@stores.store-user.custom-store-id">Custom Store ID</span></label>
                        <div *ngIf="!isEditable[i]" class="exapnd_data_det">
                          {{ data?.customStoreID }}
                        </div>
                        <input *ngIf="isEditable[i]" type="text" value="{{ data?.customStoreID }}"
                          [(ngModel)]="data.customStoreID" [ngClass]="{'change-border':data?.customStoreID}"
                          class="form-control" />
                      </div>
                      <div class="form-group">
                        <label><span i18n="@@stores.store-user.store-number">Store Number</span></label>
                        <div *ngIf="!isEditable[i]" class="exapnd_data_det">
                          {{ data?.storeNumber }}
                        </div>
                        <input *ngIf="isEditable[i]" type="text" value="{{ data?.storeNumber }}"
                          [ngClass]="{'change-border':data?.storeNumber}" class="form-control"
                          [(ngModel)]="data.storeNumber" class="form-control" />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="border-right">
                  <div class="margin-s-30">
                    <div id="expand_data_region"><span i18n="@@stores.store-user.location">Location</span></div>
                    <div class="expand_editable_data">
                      <div class="form-group">
                        <label><span i18n="@@stores.store-user.location">Location</span></label>
                        <div class="exapnd_data_det">{{ getTranslatedLoc(data?.country) }}</div>
                      </div>
                      <div class="form-group">
                        <label><span
                            i18n="@@stores.store-user.state-province-region">State/Province/Region</span></label>
                        <div *ngIf="!isEditable[i]" class="exapnd_data_det">
                          {{ data?.stateRegionProvince }}
                        </div>
                        <input *ngIf="isEditable[i]" type="text" value="{{ data?.stateRegionProvince }}"
                          [(ngModel)]="data.stateRegionProvince" [ngClass]="{'change-border':data?.stateRegionProvince}"
                          class="form-control" />
                      </div>
                      <div class="form-group">
                        <label><span i18n="@@stores.store-user.address">Address</span></label>
                        <div *ngIf="!isEditable[i]" class="exapnd_data_det">
                          {{ data?.address }}
                        </div>
                        <input *ngIf="isEditable[i]" type="text" value="{{ data?.address }}"
                          [ngClass]="{'change-border':data?.address}" class="form-control" [(ngModel)]="data.address"
                          class="form-control" />
                      </div>
                      <div class="form-group">
                        <label><span i18n="@@stores.store-user.postal-code">Postal Code</span></label>
                        <div *ngIf="!isEditable[i]" class="exapnd_data_det">
                          {{ data?.postalCode }}
                        </div>
                        <input *ngIf="isEditable[i]" type="text" value="{{ data?.postalCode }}"
                          [ngClass]="{'change-border':data?.postalCode}" class="form-control"
                          [(ngModel)]="data.postalCode" class="form-control" />
                      </div>
                    </div>
                  </div>
                </div>
                <!-- ID -->
                <div class="margin-s-30">
                  <div id="expand_data_region">ID'S</div>
                  <div class="expand_editable_data">
                    <div class="form-group">
                      <label><span i18n="@@stores.store-user.retail-hq">Retail HQ</span></label>
                      <div class="exapnd_data_det">
                        {{ data?.retailerName }}
                      </div>
                    </div>
                    <div class="form-group">
                      <label><span i18n="@@stores.store-user.created-by">Created by</span></label>
                      <div class="exapnd_data_det">
                        {{ createdByName }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </tr>

        </ng-container>
        <div id="storeTableBody" class="container">
          <div id="storeModal" class="modal-dilog" *ngIf="successPopup">
            <div class="modal-backdrop show"></div>
            <div class="modal" data-backdrop="true">
              <div id="storeModalDialog" class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                  <div class="card invitePopup">
                    <div id="storeModalHeader" class="modal-header">
                      <div id="storeModalCloseIcon" class="invitesuccessmodal-close-icon" data-dismiss="modal" (click)="closeSuccesspopup()">
                      </div>
                    </div>
                    <div id="storeModalBody" class="modal-body">
                      <div id="inviteSuccessImg" class="invitesuccess_img_div text-center">
                        <span class="invitesuccess_img"></span>
                      </div>
                      <div id="storeAddedTitle" class="invitesuccess-title text-center"><span
                          i18n="@@stores.store-user.stores-have-been-added">Stores
                          have been added</span></div>
                      <div id="storeContentText" class="invitesuccess-content text-center">
                        <span i18n="@@stores.store-user.stores-count">{{ storeCount }} stores have been added from CSV
                          to stores.</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <tr class="remove_border" *ngIf="!storesData?.length">
          <td class="profile_Record"><span *ngIf='!isLoading && isStoresTableEmpty; else loading'
              i18n="@@retail-hq.table-body.no-records-found">No Records
              Found</span></td>
          <ng-template #loading>
            <span class="text-center">{{globalConst.LOADING}}</span>
          </ng-template>
        </tr>
      </tbody>
    </table>
  </div>
  <!-- Pagination -->
  <div id="footerSec" class="data_footer position-relative">
    <button *ngIf="storesData?.length" type="button"
      class="btn btn-outline-primary left_icon_btn download_btn gtmUsersStoresDownloadCSV" (click)="downloadCsvFile()"
      [disabled]="storesData?.length == 0">
      <img class="downloadbtn" alt="download" />
      <span i18n="@@stores.store-user.download-csv">Download CSV</span>
    </button>
    <div id="profilesPagination" class="d-flex flex-column align-items-center" *ngIf="storesData?.length > 0">
      <nav aria-label="existing profiles pagination">
        <ngb-pagination [collectionSize]="paginationCount" [(page)]="page" [pageSize]="tableSize" [rotate]="false"
          [maxSize]="maxSize" [ellipses]="true" [maxSize]="10" [boundaryLinks]="false"
          (pageChange)="onTableDataChange($event)">
        </ngb-pagination>
      </nav>
      <div id="storesResult" class="results mt-2">
        <span i18n="@@stores.store-showing.showing" class="showing">Showing <strong>{{ showFrom }} - {{
            showTo }}</strong> of <strong>{{ paginationCount }} Stores</strong></span>
      </div>
    </div>
  </div>
</div>
<!-- Popup Modal starts Here -->
<!-- create a new store -->
<div id="createStore" class="container" *ngIf="showCreatePopup">
  <div id="createStoreBackdrop" class="modal-backdrop show"></div>
  <!-- The Modal -->
  <div id="createStoreModal" class="modal" id="myModal">
    <div id="createStoreForm" class="modal-dialog modal-dialog-centered">
      <form [formGroup]="storeForm">
        <div id="createModalCont" class="modal-content modalSize">
          <!-- Modal body -->
          <div id="createModalCloseIcon" class="modal-body location-search">
            <button type="button" class="close" data-dismiss="modal">
              <img class="modal-close-icon" (click)="onClose()" alt="closepopup" />
            </button>
            <h1 class="heading"><span i18n="@@stores.store-user.new-store">New Store</span></h1>
            <div id="newstoreName" class="row">
              <div id="storeName" class="form-group col-6">
                <label><span i18n="@@stores.store-user.store-name">Store Name</span><span class="text-danger">*</span>
                </label>
                <input type="text" maxlength="100" class="form-control" (ngModelChange)="onStoreNameType($event)"
                  [(ngModel)]="storeName" formControlName="storeName" placeholder={{storeNamePlaceholderText}}
                  [class.has-error]="isStoreNameUnique" />
                <em class="error-icon" *ngIf="isStoreNameUnique"></em>
                <div *ngIf="isStoreNameUnique" class="text-danger err-field"><span
                    i18n="@@stores.store-user.store-name-unique-error">Store Name already exists</span></div>
              </div>
              <div id="retailHq" class="form-group col-6">
                <label for="OS" id="btnCountry"><span i18n="@@stores.store-user.retail-hq">Retail HQ</span><span
                    class="text-danger">*</span></label>
                <ng-container *ngIf='(userRole !== retailHqUser && userRole !== regionalHQ); else retaillabel'>
                  <div id="retailHqValue" class="drop-search retailSearchTopMargin" [ngClass]="{'custom-margin-top': isGerman || isUkraine}">
                    <ng-select [items]="allRetailHqData" placeholder="{{retailStoreConst.RETAILHQ_VALUE}}"
                      bindLabel="retailerName" name="retailer" [clearable]="true" [searchFn]="retailerSearchFn"
                      [ngbTooltip]="retailHQValueCopy?.retailerName ? retailHQValueCopy?.retailerName?.length > 25 ? retailHQValueCopy?.retailerName:'':''"
                      [(ngModel)]="valueForRetailHq" [ngModelOptions]="{standalone: true}" [selectOnTab]="true"
                      (change)="onRetailChange($event)">
                    </ng-select>
                    <div id="retailValueSearch" *ngIf="!valueForRetailHq" class="search-icon"></div>
                  </div>
                </ng-container>
                <ng-template #retaillabel>
                  <button type="button" class="btn btn-primary disableHand retailSearchTopMargin" [ngClass]="{'custom-margin-top': isGerman || isUkraine}" id="countryDropDown"
                    aria-haspopup="true" aria-expanded="false" title="{{hoverValueForRetailHQ}}">
                    {{ valueForRetailHq }}
                  </button>
                </ng-template>
              </div>
            </div>
            <div class="mt-3" #borderline></div>
            <div id="storeNumber" class="row">
              <div id="storeNumberInput" class="form-group col-6 mt-3">
                <label><span i18n="@@stores.store-user.store-number">Store Number</span></label>
                <input type="text" class="form-control" maxlength="60" formControlName="storeNumber"
                  placeholder={{storeNumberPlaceholderText}} />
              </div>
              <div id="customStoreId" class="form-group col-6 mt-3">
                <label><span i18n="@@stores.store-user.custom-store-id">Custom Store ID</span></label>
                <input type="text" class="form-control" maxlength="60" formControlName="customStoreId"
                  placeholder={{customerIdPlaceholderText}} />
              </div>
            </div>
            <div class="mt-3" #borderline></div>
            <div id="location" class="row">
              <div id="locationText" class="form-group col-6 mt-3">
                <label for="OS" id="btnCountry"><span i18n="@@stores.store-user.location">Location</span><span
                    class="text-danger">*</span></label><br />
                <div id="locationDropSearch" class="drop-search">
                  <ng-select [items]="allCountries" placeholder="{{ locationSearch }}" bindLabel="CountryName"
                    name="country" [clearable]="true" [searchFn]="countrySearchFn"
                    [ngbTooltip]="locationValueCopy?.CountryName ? locationValueCopy?.CountryName?.length > 25 ? locationValueCopy?.CountryName:'':''"
                    [(ngModel)]="valueForCountry" [ngModelOptions]="{standalone: true}" [selectOnTab]="true"
                    (change)="onCountryChange($event)">
                  </ng-select>
                  <div id="searchIcon" *ngIf="!valueForCountry" class="search-icon"></div>
                </div>
              </div>
              <div id="regionInput" class="form-group col-6 mt-3">
                <label> <span i18n="@@stores.store-user.state-province-region">State/Province/Region</span></label>
                <input type="text" class="form-control" formControlName="regionName" maxlength="60"
                  placeholder={{stateProviceRegionPlaceholderText}} />
              </div>
            </div>
            <div class="row">
              <div id="addressInput" class="form-group col-6">
                <label><span i18n="@@stores.store-user.address">Address</span></label>
                <input type="text" class="form-control" maxlength="60" formControlName="addressValue"
                  placeholder={{addressPlaceholderText}} />
              </div>
              <div id="postalCodeInput" class="form-group col-6">
                <label> <span i18n="@@stores.store-user.postal-code">Postal Code</span></label>
                <input type="text" class="form-control" maxlength="20" formControlName="postalCode"
                  placeholder={{postalCodePlaceholderText}}
                  [class.has-error]="storeForm?.controls?.postalCode?.errors?.pattern" />
                <em class="error-icon" *ngIf="storeForm?.controls?.postalCode?.errors?.pattern"></em>
                <div id="invalidPostalCode" *ngIf="storeForm?.controls?.postalCode?.errors?.pattern" class="text-danger">
                  <span i18n="@@stores.store-user.postal-code-error-message">Postal Code should not contain
                    special characters or space. Please try again.</span>
                </div>
              </div>
            </div>
          </div>
          <!-- Modal footer -->
          <div id="createModalFooter" class="modal-footer">
            <button type="button" class="btn btn-outline-primary gtmUsersStoresCancel" (click)="onClose()">
              <span i18n="@@stores.store-user.cancel-button">Cancel</span>
            </button>
            <button type="button" class="btn btn-primary gtmUsersStoresCreateStore"
              [disabled]="!validator || isStoreNameUnique" (click)="onCreateStore()">
              <span i18n="@@stores.store-user.create-store" class="gtmUsersStoresCreateStore">Create Store</span>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
  <!-- Popup Modal ends Here -->
</div>

<!-- invite store user -->
<div id="showInvitePopUp" class="container" *ngIf="showInvitePopup">
  <div id="showInviteModal" class="modal-backdrop show"></div>
  <!-- The Modal -->
  <div class="modal" id="inviteUserModal">
    <div id="showInviteForm" class="modal-dialog modal-lg">
      <form [formGroup]="inviteUserForm">
        <div id="showInviteContent" class="modal-content">
          <!-- Modal body -->
          <div id="showInviteModalBody" class="modal-body">
            <button type="button" class="close" data-dismiss="modal" (click)="onCloseInvite()">
              <img class="modal-close-icon" alt="close" /></button>
            <h1 class=heading><span i18n="@@stores.store-invite.invite-user-to">Invite User to {{storeName}}</span></h1>
            <div class=row>
              <div id="inviteEmail" class="form-group col-8">
                <label for="email"><span i18n="@@stores.store-user.email-adresses">Email Addresses</span><span
                    class="text-danger">*</span>
                </label>
                <div id="multiEmailInvite" class="form-group form-group-md multi_email" #wrap>
                  <div class="global-filter-chips">
                    <div id="userEmails" class="global-filter-chip" *ngFor="let email of userEmailAddresses;  let i= index">
                      <span class="global-filter-chip-text" (dblclick)="editEmail(i)">
                        {{email}}
                      </span>
                      <div id="deleteEmailIcon" class="remove-global-filter-btn" (click)="deleteEmail(i)">
                        <img class="modal-close-icon" alt="close" />
                      </div>
                    </div>
                  </div>
                  <div id="editEmail" *ngIf="checkEdit">
                    <input type="text" [placeholder]="" (paste)="onPaste($event)" (keyup)="onKeyUp($event)"
                      class="form-control" formControlName="emailAddress" (input)="avoidSpecialChar($event)"
                      class="editEmail">
                  </div>
                  <textarea *ngIf="!checkEdit" rows="1" id="email" name="email" class="form-control"
                    formControlName="emailAddress"
                    [placeholder]="userEmailAddresses?.length ? '':(storesInvite+' '+storeName)" required value=''
                    (paste)="onPaste($event)" (input)="avoidSpecialChar($event)" (keyup)="onKeyUp($event)"
                    (focus)="addBorder(wrap)" (blur)="removeBorder(wrap)"></textarea>
                </div>
                <div id="requiredEmailText" *ngIf="!isEmailrequired" class="formfield_err_msg"> <span
                    i18n="@@stores.store-user.this-required-field">This is a required field.</span>
                </div>
                <div id="invalidEmailText" class="formfield_err_msg" *ngIf="!isEmailValid"><span
                    i18n="@@stores.store-user.please-provide-email">Please provide a valid email address.</span></div>
                <div id="duplicateEmailText" class="formfield_err_msg" *ngIf="checkDuplicate"><span
                    i18n="@@stores.store-user.email-duplicate.email-already-added">Email already added</span></div>
                <div id="duplicateEmailError" class="formfield_err_msg" *ngIf="checkDuplicateCount>0"><span
                    i18n="@@stores.store-user.email-register.email-already-registered">Email already Registered</span>
                </div>
              </div>
              <div id="storeRole" class="form-group col-4 ">
                <label for="OS"><span i18n="@@stores.store-user.role">Role</span></label>
                <button type="button" class="btn store-color btn-sm disableHand"><span
                    i18n="@@stores.store-user.store-button">Store</span></button>
                <div id="storeName" class="form-group mt-3">
                  <label for="OS"><span i18n="@@stores.store-user.assigned-store">Assigned Store</span></label>
                  <button type="button"
                    class="btn btn-primary btn-sm disableHand store-name-width"><span class="store-name-width-span">{{storeName}}</span></button>
                </div>
              </div>
            </div>
          </div>
          <!-- Modal footer -->
          <div id="inviteModalFooter" class="modal-footer">
            <button type="button" class="btn btn-outline-primary gtmUsersStoresCancelInvite"
              (click)="onCloseInvite()"><span i18n="@@stores.store-user.cancel-button">Cancel</span></button>
            <button type="button" class="btn btn-primary gtmUsersStoresInvite" (click)="onInviteStore()"> <span
                i18n="@@stores.store-user.invite-user-button">Invite
                User</span></button>
          </div>
        </div>
      </form>
    </div>
  </div>
  <!-- Popup Modal ends Here -->
</div>
<!-- invite store user success popup -->
<div id="successInvitePopUp" class="container" *ngIf="showsuccessInvitePopup">
  <div id="modalBackdrop" class="modal-backdrop show"></div>
  <!-- The Modal -->
  <div class="modal" id="successUserModal">
    <div id="inviteModalDialog" class="modal-dialog modal-lg">
      <div id="inviteModalCont" class="modal-content">
        <div id="inviteModalCard" class="card invitePopup">
          <div id="inviteModalHeader" class="modal-header">
            <div id="inviteCloseIcon" class="invitesuccessmodal-close-icon" data-dismiss="modal" (click)="onCloseSuccessPopup()"></div>
          </div>
          <!-- Modal body -->
          <div id="inviteModalBody" class="modal-body invitesuccess-panel">
            <div id="inviteSuccessImg" class="invitesuccess_img_div text-center">
              <span class="invitesuccess_img"></span>
            </div>
            <div id="invitSentTitle" class="invitesuccess-title text-center">
              <span i18n="@@stores.store-user.invite-sent">Invite Sent</span>
            </div>
            <div id="invitedEmail" class="invitesuccess-content text-center">
              <span i18n="@@stores.store-user.invite-sent-to" class="text-center">Invite sent to {{invitedEmailString}}
                for {{storeName}}.</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Popup Modal ends Here -->
</div>